<template>
  <span
    v-if="patient && patient.id"
    class="patient-tag-picker"
  >
    <a
      :id="targetId"
      href="#"
      class="small-text"
      @click.prevent
      >แก้ไข tag</a
    >
    <b-popover
      :target="targetId"
      triggers="click blur"
      placement="bottom"
      :show.sync="open"
      @show="selected = [...(patient.tagIds || [])]"
    >
      <div
        v-if="!options.length"
        class="small-text text-muted"
      >
        ยังไม่มีรายการ tag
      </div>
      <b-form-checkbox-group
        v-else
        v-model="selected"
        stacked
        :options="options"
        class="mb-2"
      />
      <div
        v-if="options.length"
        class="d-flex justify-content-end"
      >
        <b-button
          size="sm"
          variant="primary"
          :disabled="isSaving"
          @click="save"
          >บันทึก</b-button
        >
      </div>
    </b-popover>
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/main";

let uid = 0;

export default {
  name: "PatientTagPicker",
  props: {
    patient: { type: Object, default: null },
  },
  data() {
    uid += 1;
    return {
      targetId: `tag-picker-${uid}`,
      open: false,
      selected: [],
      isSaving: false,
    };
  },
  computed: {
    ...mapGetters({ tagList: "moduleMaster/getPatientTagList" }),
    options() {
      return (this.tagList || []).map(t => ({ value: t.val, text: t.label }));
    },
  },
  methods: {
    async save() {
      this.isSaving = true;
      try {
        const res = await this.$store.dispatch(
          "modulePatient/savePatientTags",
          {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            patient: this.patient,
            tagIds: this.selected,
          }
        );
        this.open = false;
        this.$emit("saved", res.data);
      } catch (e) {
        eventBus.$emit("alertToast", {
          message:
            e && e.message === "PATIENT-INCOMPLETE"
              ? "ข้อมูลคนไข้ไม่ครบ กรุณาเปิดโปรไฟล์คนไข้แล้วลองใหม่"
              : "บันทึก tag ไม่สำเร็จ",
          variant: "danger",
        });
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
